<template>
  <div
    v-if="hits.length"
    class="p-10 md:p-15 bg-gray-100 border border-gray-300 mb-30"
  >
    <div>
      <SpriteSymbol
        name="pharmasuisse"
        class="w-40 h-40 float-right text-green-alt"
      />
      <h3 class="text-md md:text-lg !leading-none font-semibold">
        {{
          $texts('search.findPharmaciesTeaserTitle')
        }}
      </h3>
      <ul class="text-sm grid gap-5 mt-20 lg:grid-cols-3 lg:text-base">
        <li v-for="(hit, index) in hits" :key="index">
          <NuxtLink class="link flex items-center" :to="hit.url">
            <SpriteSymbol name="arrow" class="h-10 w-15 mr-5 inline-block" />
            <span>{{ hit.name }}</span>
          </NuxtLink>
        </li>
      </ul>

      <NuxtLink
        v-if="total > 1"
        :to="{ name: 'navigator', query: { text } }"
        class="button is-primary is-narrow mt-30"
      >
        {{
          $texts('search.findPharmaciesTeaserCta')
        }}
      </NuxtLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { GenericQueryParams } from '~/types/query'
import type {
  PharmacyDocument,
  SearchPharmaciesResponse,
} from '#pharmago/shared/types'

const props = defineProps<{
  text: string
}>()

const language = useCurrentLanguage()

const query = computed<GenericQueryParams>(() => {
  return {
    size: 6,
    langcode: language.value,
    text: props.text.toLowerCase(),
  }
})

const { data } = await useFetch<SearchPharmaciesResponse>('/api/pharmacies', {
  query,
})

const total = computed<number>(() => data.value?.total || 0)
const hits = computed<PharmacyDocument[]>(() => data.value?.hits || [])
</script>
